import { getFirebaseConfig } from '@/utils/client/client_api';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';


export const getFirebaseApp = async () => {
    try {
        const firebaseConfigRes = await getFirebaseConfig();
        return getApps().length > 0 ? getApp() : initializeApp(firebaseConfigRes.response);
    } catch (e) {
        console.log(e)
    }
    return undefined
}

export const getFirebaseClientAuth = async () => {
    try {
        const firebaseApp = await getFirebaseApp()
        if (firebaseApp) {
            const fireabaseAuth = getAuth(firebaseApp);
            await fireabaseAuth.authStateReady();
            return fireabaseAuth;
        }
    } catch (e) {
        console.log(e)
    }
    return undefined
}